<div class="references-content">
    <!-- Thank you message -->
    <div class="mb-4 p-3 bg-gray-50 border-l-4 border-gray-300">
        <p class="text-sm text-gray-700">
            The population data and reference ranges used in these comparisons are based on the following research
            studies. Thank you to the researchers for allowing us to use and reference their data. The hard work and
            scientific effort behind this tool comes entirely from the studies and data these researchers have gathered.
        </p>
    </div>

    <!-- Western Data & Graphs -->
    <div class="mb-4">
        <h4 class="text-lg font-semibold mb-2 text-gray-800">{{ referencesData.western.title }}</h4>
        <ol class="pl-4">
            <li *ngFor="let reference of referencesData.western.references" class="mb-3 text-sm leading-6">
                {{ reference.text }}
            </li>
        </ol>
    </div>

    <!-- Eastern Data & Graphs -->
    <div class="mb-4">
        <h4 class="text-lg font-semibold mb-2 text-gray-800">{{ referencesData.eastern.title }}</h4>
        <ol class="pl-4" start="4">
            <li *ngFor="let reference of referencesData.eastern.references" class="mb-3 text-sm leading-6">
                {{ reference.text }}
            </li>
        </ol>
    </div>

    <!-- Progression data -->
    <div class="mb-4">
        <h4 class="text-lg font-semibold mb-2 text-gray-800">{{ referencesData.progression.title }}</h4>
        <ol class="pl-4" start="6">
            <li *ngFor="let reference of referencesData.progression.references" class="mb-3 text-sm leading-6">
                {{ reference.text }}
            </li>
        </ol>
    </div>
</div>